export const PromiseStatus = {
    Fullfiled: "fulfilled",
    Rejected: "rejected",
};

export const HttpStatusCode = {
    OK: 200,
    BAD_REQUEST: 400,
    CSRF_ERROR: 419,
};

export const ErrorCode = {
    /** 1. Internal Error Code**/
    INVALID_INPUT: 1001,
    DATABASE_ERROR: 1002,
    FIREBASE_ERROR: 1003,

    /** 2. My Page Error Code **/
    AUTHENTICATION_FAILED: 2001,
    USER_NOT_FOUND: 2002,
    INCORRECT_PASSWORD: 2003,
    PASSWORD_CHANGE_FAILED: 2004,
    EMAIL_ALREADY_EXISTS: 2005,
    EMAIL_UPDATE_FAILED: 2006,

    /***** 3. Scout - Apply *****/
    SCOUTED_ALREADY: 3001,
    APPLIED_ALREADY: 3002,
};
